import { ErrorCode, PortalApiError } from '@afterpaytouch/portal-api/types'
import { Route } from '../../config/router'
import { TrackingEvent } from '../../model/monitoring'
import { ErrorHandler, CheckoutErrorContext } from './types'

export const createCheckoutStartDefaultTerminalErrorHandler = (): ErrorHandler => ({
  canHandle: (): boolean => {
    return true // Always handles as fallback
  },

  handle: async (errorCode: ErrorCode, _error: PortalApiError, context: CheckoutErrorContext): Promise<Route> => {
    context.logEvent(TrackingEvent.CHECKOUT_DECLINED, {
      isRecoverableTerminalError: false,
      errorCode,
    })

    return Route.TERMINAL_ERROR
  },
})
